module.exports = __webpack_public_path__ + "img/icbc_banner.a5e1c6fc.jpg";